import _ from "lodash";
import { useEffect, useState } from "react";
import localize from "../../../common/localize";
import Combobox from "../../../components/common/Combobox";
import useGlobalContext from "../../../hooks/useGlobalContext";
import { Alert, Box } from "@mui/material";
import TrueFalseImage from "../../../components/TrueFalseImage";

export default function ManageUserProfile() {
  const { userModel, setUserModel, profileData } = useGlobalContext();
  const [userProfile, setUserProfile] = useState(null);

  const handleUserProfileChange = (profile) => {
    if (!profile) {
      const removedUserRole = _.omit(userModel, "NewRole");
      setUserProfile(null);
      setUserModel({ ...removedUserRole });
      return;
    }
    setUserModel({ ...userModel, NewRole: profile });
    setUserProfile(profile);
  };

  useEffect(() => {
    if (userModel?.UserRoles?.length > 0) {
      setUserProfile(userModel?.UserRoles?.[0]);
    }
  }, [userModel.Id]);

  return (
    <div style={{ width: "100%" }}>
      <form className="w-full mt-2">
        <div className="flex flex-col gap-2 mb-6">
          <Box className="flex flex-col gap-2">
            <Box className="flex gap-2 justify-between">
              <Box className="two_columns_grid">
                <label className="text-xs">
                  <b>{localize.username}:</b>
                </label>
                <label className="text-xs">{userModel.UserName}</label>
                <label className="text-xs">
                  <b>{localize.full_name}:</b>
                </label>
                <label className="text-xs">{userModel.FullName}</label>
              </Box>
            </Box>

            <Alert severity="info" className="w-full">
              <label className="text-xs">
                {localize.profile_assignment_information}
              </label>
            </Alert>

            <Combobox
              isRequired
              id="UserProfile"
              handleValueChange={handleUserProfileChange}
              fieldValue={userProfile ?? null}
              fieldOptions={profileData.Data ?? []}
              fieldLabel={localize.profile}
              customOptionLabel={(option) => `${option.Name}`}
            />
          </Box>
        </div>
      </form>
    </div>
  );
}
